var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"peixun"},[_c('canvas',{ref:"canvas",attrs:{"id":"canvas","width":"800","height":"1200"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }